"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonSelect = void 0;
const index_1 = require("../index");
const react_1 = __importDefault(require("react"));
const icons_1 = require("../../icons");
/**
 * @deprecated - this component is being deprecated in favor of ButtonGroup. ButtonGroup is styled significantly differently
 * based on the needs of the facility client.  If the old style is still needed, please add it as a variant to ButtonGroup
 */
const ButtonSelect = ({ value: selected, onChange, options, ButtonProps = {}, }) => (react_1.default.createElement(react_1.default.Fragment, null, options.map(({ value, label, disabled }) => {
    const isSelected = selected === value;
    return (react_1.default.createElement(index_1.Button, { sx: {
            margin: '10px',
            '&:first-of-type': {
                marginLeft: 0,
            },
            '&:last-of-type': {
                marginRight: 0,
            },
            ...ButtonProps.sx,
        }, variant: isSelected ? 'contained' : 'muted', color: isSelected ? 'secondary' : undefined, startIcon: isSelected && react_1.default.createElement(icons_1.Check, { "data-testid": "check-icon" }), disabled: disabled, key: value?.toString(), onClick: () => onChange(value), ...ButtonProps }, label));
})));
exports.ButtonSelect = ButtonSelect;
exports.default = exports.ButtonSelect;
